import API from 'api/endpoints';
import axiosInstance from 'api/axiosInstance';



export const designationService = {
  getDesignations: async (level = null) => {
    try {
      const payload = {};
      if (level !== null) payload.Level = level;

      const response = await axiosInstance.get(API.designation.getAll, payload);
      return response.data;
    } catch (error) {
      console.error("Error fetching designations with count:", error);
      throw error;
    }
  },

  getRankOptions: async ( level) => {
    try{
          const response = await axiosInstance.get(API.designation.getRank(level))
          return response.data
    }
    catch(error){
  console.error("error",error);
  throw error;
    }
  },

  createDesignation : async(payload) => {
    try{
          const response = await axiosInstance.post(API.designation.create,payload);
          return response.data;                   
    }
    catch(error){
      console.error("error in submition",error);
      throw error;
    }
  }
};